import { render, staticRenderFns } from "./DocumentationSection.vue?vue&type=template&id=196db87f&scoped=true&"
import script from "./DocumentationSection.vue?vue&type=script&lang=js&"
export * from "./DocumentationSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationSection.vue?vue&type=style&index=0&id=196db87f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196db87f",
  null
  
)

export default component.exports